import { Group } from '@mantine/core';
import { baseWhite, secondaryBase } from '../../styles/design-tokens';
import { Button } from '../../ui-library/button/button';
import { Icon } from '../../ui-library/icon/icon';
import { getViewTypeTitle } from '../process/process.helpers';
import { VALUE_TYPE_ICONS, ViewType } from '../process/process.type';

export const ProcessTabs = ({
  viewType,
  setViewType,
}: {
  viewType: ViewType;
  setViewType: (viewType: ViewType) => void;
}) => {
  return (
    <Group gap="xs">
      {Object.values(ViewType).map((value) => (
        <Button
          size="xs"
          radius="xl"
          key={value}
          variant={value === viewType ? 'secondary' : 'outline'}
          onClick={() => setViewType(value)}
          leftSection={
            <Icon name={VALUE_TYPE_ICONS[value]} color={value === viewType ? baseWhite : secondaryBase} size={16} />
          }
        >
          {getViewTypeTitle(value)}
        </Button>
      ))}
    </Group>
  );
};
